class Proptypes {
  static __buildType =
    (type) =>
    (defaultValue = null, options = {}) => {
      const typeObject = {
        ...options,
        type,
      }
      if (typeof defaultValue !== 'undefined' && defaultValue !== null) {
        return {
          ...typeObject,
          default: defaultValue,
        }
      }

      return {
        ...typeObject,
        required: true,
      }
    }

  static string = Proptypes.__buildType(String)

  static boolean = Proptypes.__buildType(Boolean)

  static array = Proptypes.__buildType(Array)

  static object = Proptypes.__buildType(Object)

  static number = Proptypes.__buildType(Number)

  static function = Proptypes.__buildType(Function)

  static any = Proptypes.__buildType
}

window.Proptypes = Proptypes
